var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("没有找到面板ListPanel2")])
}
var staticRenderFns = []

export { render, staticRenderFns }